import { useDropdownContext } from "../Dropdown";
import { MenuDivider } from "./MenuDivider";
import { MenuHeader } from "./MenuHeader";
import { MenuOptionItem } from "./MenuOptionItem";
import type { IMenuItem } from "./types";
import {
  isMenuCustomElement,
  isMenuDivider,
  isMenuHeader,
  isMenuOption,
} from "./types";
import { Fragment } from "react";

type Props = {
  options: IMenuItem[];
};

export const MenuContent = ({ options }: Props) => {
  const { activeIndex, contentId } = useDropdownContext();

  const activeDescendant =
    activeIndex !== null ? `${contentId}-option-${activeIndex}` : undefined;
  let optionIndex = 0;

  return (
    <div
      className="nuco-menu__option-wrapper"
      aria-activedescendant={activeDescendant}
    >
      {options.map((item, index) => {
        if (isMenuDivider(item)) {
          return <MenuDivider key={index} item={item} />;
        }

        if (isMenuHeader(item)) {
          return <MenuHeader key={index} item={item} />;
        }

        if (isMenuCustomElement(item)) {
          return <Fragment key={index}>{item.element}</Fragment>;
        }

        if (isMenuOption(item)) {
          const currentIndex = optionIndex;
          optionIndex++;
          return (
            <MenuOptionItem key={item.id} option={item} index={currentIndex} />
          );
        }

        return null;
      })}
    </div>
  );
};
